import { Component } from "react";
import { getCPFYears } from "../../../../managers/common/CommonUtil";
import RouteManager from "../../../../managers/RouteManager";
import MYReport from "./MYReport";
import { MY_REPORTS } from "./MYReportConstants";

export default class KWSPBorangA extends Component {
    data = {
        title: 'KWSP Borang A',
        yearOptions: getCPFYears(),
        actionBtn: ['downloadForm','downloadTextFile','downloadCsvFile'],
        fields: ['accountId','submissionMedia','year','month'],
        fileName:'BorangA',
        defaultValues:{
            year: new Date().getFullYear(),
            month: new Date().getMonth()+1,
            formType: MY_REPORTS.BORANGA,
            submissionMedia: 'DSB'
        }
    }
    constructor(props) {
        super(props)
        RouteManager.setPresenter(this);
    }
    onButtonClick(btn) {

    }
    render() {
        return(
            <MYReport data={this.data} onButtonClick={(btn)=>{this.onButtonClick(btn)}}/>
        )
    }
}